import { render } from "./AddDevelopmentSidepanel.vue?vue&type=template&id=94e35c56&scoped=true"
import script from "./AddDevelopmentSidepanel.vue?vue&type=script&lang=js"
export * from "./AddDevelopmentSidepanel.vue?vue&type=script&lang=js"

import "./AddDevelopmentSidepanel.vue?vue&type=style&index=0&id=94e35c56&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94e35c56"]])

export default __exports__